<template>
  <b-container fluid class="inquiries">
    <b-row>
      <b-col>
        <div class="text-left text-uppercase title p-3">
          All Inquiries
        </div>
      </b-col>
    </b-row>
    <b-row class="m-2">
      <b-col lg="4" md="4" sm="12" xs="12" class="box text-left mb-3 pb-3 pt-2" v-for="(inquiry, index) in inquiries" :key="index" :class={even:index%2}>
        <!-- <div>Service : {{inquiry.service}}</div> -->
        <div>Name : {{inquiry.name}}</div>
        <div>Email : {{inquiry.email}}</div>
        <div>Phone No. : {{inquiry.phoneNumber}}</div>
        <!-- <div class="text-justify">Inquiry : {{inquiry.question}}</div> -->
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'Inquiries',
  data () {
    return {
      isLoading: false,
      inquiries1: [
        {
          id: '1',
          name: 'Budi',
          email: 'budi@gmail.com',
          phoneNumber: '08528909991',
          inquiry: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
          service: 'Construction'
        },
        {
          id: '2',
          name: 'Dodi',
          email: 'dodi@yahoo.com',
          phoneNumber: '08528909392',
          inquiry: 'The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.',
          service: 'Repairment'
        },
        {
          id: '3',
          name: 'Ekanda',
          email: 'ekanda@commerce.com',
          phoneNumber: '08123458909',
          inquiry: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
          service: 'Repairment'
        },
        {
          id: '4',
          name: 'Fendi',
          email: 'fendi@yahoo.com',
          phoneNumber: '08123423423',
          inquiry: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
          service: 'Construction'
        },
        {
          id: '5',
          name: 'Gilang',
          email: 'gilang@mail.com',
          phoneNumber: '08528909392',
          inquiry: 'quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
          service: 'Repairment'
        }
      ]
    }
  },
  methods: {
    getAllInquiries (page) {
      this.isLoading = true
      this.$store.dispatch('getAllInquiries', {
        data: {
          page: page
        },
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get inquiries. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  },
  created () {
    this.getAllInquiries(0)
  },
  computed: {
    ...mapGetters([
      'inquiries'
    ])
  }
}
</script>

<style scoped>
.inquiries {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box {
  border-bottom: 1px solid #BDBDBD;
}
.box img {
  width: 100%;
}
.actionBtn {
  float:right;
  margin-top: 5px;
  margin-left: 15px;
  color: #455A64;
}
.actionBtn:hover {
  cursor: pointer;
  color: #000;
  text-decoration: underline;
}
.addBtn {
  background-color: #FF8F00;
  padding: 5px 25px;
  text-transform: capitalize;
  margin-left: 50px;
  color: #fff;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.addBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Inquiries.vue